module.exports = __webpack_public_path__ + "img/29_36.f7172c18.png";